import { Controller } from '@hotwired/stimulus';
import { toggle, leave } from '../transition';

export default class extends Controller {
    static targets = ['btn', 'content'];

    connect() {
        const attributes = {
            'data-transition-enter-end': 'transform opacity-100 scale-100',
            'data-transition-enter-start': 'transform opacity-0 scale-95',
            'data-transition-enter': 'transition ease-out duration-100',
            'data-transition-leave-end': 'transform opacity-0 scale-95',
            'data-transition-leave-start': 'transform opacity-100 scale-100',
            'data-transition-leave': 'transition ease-in duration-75'
        };

        for (const [attr, value] of Object.entries(attributes)) {
            if (!this.contentTarget.hasAttribute(attr)) {
                this.contentTarget.setAttribute(attr, value);
            }
        }
    }

    close(event) {
        if (!this.btnTarget.contains(event.target) && !this.contentTarget.contains(event.target)) {
            leave(this.contentTarget).then();
        }
    }

    toggle() {
        toggle(this.contentTarget).then();
    }
}
